var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "register-card"
  }, [_c('div', {
    staticClass: "signup-header"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": require("@/assets/images/signup/logo.svg"),
      "alt": "Cascade Logo"
    }
  }), _c('selector', {
    staticClass: "p-1"
  })], 1), _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "signup-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('signup.header')) + " ")]), _c('div', {
    staticClass: "mb-5"
  }, [_vm._v(" " + _vm._s(_vm.$t('signup.form.add-information')) + " ")]), _c('signup-form', {
    attrs: {
      "error": _vm.signupError,
      "show-legal-consents": ""
    },
    on: {
      "submit": _vm.onSubmit
    },
    scopedSlots: _vm._u([{
      key: "back",
      fn: function () {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Login'
            }
          }
        }, [_c('b-button', {
          staticClass: "btn-back w-100",
          attrs: {
            "variant": "white"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('signup.button.back-to-login')) + " ")])], 1)];
      },
      proxy: true
    }])
  })], 1)])]), _c('div', {
    staticClass: "other-side"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/signup/signup_picture.png"),
      "alt": ""
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }